import snapshot from './data/program.json'
import type { Program } from './domain/program-schema.ts'

/**
 * The committed programme snapshot.
 *
 * Bundled rather than fetched: the day view needs all of it on first paint anyway,
 * and bundling means the whole programme — including the blur placeholders — is
 * available offline with no extra request. See KTD7.
 */
export const program = snapshot as Program

export const CONCERTS = program.concerts
export const DAYS = program.days
export const STAGES = program.stages
